module.exports = __webpack_public_path__ + "static/img/aboutUs13.a5f1ba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs13.jpg
// module id = 1365
// module chunks = 1